import { render, staticRenderFns } from "./DisputeDialog.vue?vue&type=template&id=7c499ab9&scoped=true&"
import script from "./DisputeDialog.vue?vue&type=script&lang=js&"
export * from "./DisputeDialog.vue?vue&type=script&lang=js&"
import style0 from "./DisputeDialog.vue?vue&type=style&index=0&id=7c499ab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c499ab9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c499ab9')) {
      api.createRecord('7c499ab9', component.options)
    } else {
      api.reload('7c499ab9', component.options)
    }
    module.hot.accept("./DisputeDialog.vue?vue&type=template&id=7c499ab9&scoped=true&", function () {
      api.rerender('7c499ab9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_dialogs/DisputeDialog.vue"
export default component.exports